<app-dialog-basic [dialogTitle]="dialogTitle" [isLoading]="daigakuEditing">
  <form [formGroup]="daigakuForm">
    <!-- 大学名 -->
    <mat-form-field class="block mb-4" appearance="outline">
      <mat-label>大学名</mat-label>
      <input matInput formControlName="daigakuName" />
      <mat-error *ngIf="daigakuForm.get('daigakuName').hasError('required')">入力してください</mat-error>
    </mat-form-field>

    <!-- 学部・学科・研究室名等 -->
    <mat-form-field class="block mb-4" appearance="outline">
      <mat-label>学部・学科・研究室名等(任意)</mat-label>
      <input matInput formControlName="daigakuSubName" />
    </mat-form-field>

    <!-- 大学申込コード -->
    <mat-form-field class="block mb-4" appearance="outline">
      <mat-label>大学申込コード</mat-label>
      <input matInput formControlName="daigakuCode" />
      <mat-error *ngIf="daigakuForm.get('daigakuCode').hasError('required')">入力してください</mat-error>
      <mat-error *ngIf="daigakuForm.get('daigakuCode').hasError('minlength')">6桁の半角数字（6桁の半角数字を入力してください）</mat-error>
      <mat-error *ngIf="daigakuForm.get('daigakuCode').hasError('maxlength')">6桁の半角数字（6桁の半角数字を入力してください）</mat-error>
      <mat-error *ngIf="daigakuForm.get('daigakuCode').hasError('pattern')"
        >6桁の半角数字を入力してください（6桁の半角数字を入力してください）</mat-error
      >
    </mat-form-field>

    <!-- 都道府県 -->
    <mat-form-field class="block mb-4" appearance="outline">
      <mat-label>都道府県</mat-label>
      <mat-select formControlName="prefectureId">
        <mat-option *ngFor="let prefecture of prefectures" [value]="prefecture.id">{{ prefecture.name }}</mat-option>
      </mat-select>
      <mat-error *ngIf="daigakuForm.get('prefectureId').hasError('required')">選択してください</mat-error>
    </mat-form-field>

    <div class="mt-4">
      ※ 大学申込コードは入力された6桁の先頭に「U-」が自動的に付与されます
    </div>
  </form>

  <div class="progress-48">
    <mat-spinner [diameter]="48" @enter *ngIf="daigakuEditing"></mat-spinner>
  </div>

  <app-dialog-basic-footer>
    <div class="text-danger text-sm mr-auto" @enter *ngIf="errorMessage !== ''">{{ errorMessage }}</div>
    <button mat-stroked-button (click)="cancel()" [disabled]="daigakuEditing">キャンセル</button>
    <button mat-flat-button color="primary" (click)="editDaigaku()" [disabled]="daigakuEditing">更新</button>
  </app-dialog-basic-footer>
</app-dialog-basic>
